import {
    Nav,
} from 'reactstrap';
import { HistoryNavLinkBase, PatientInfoTabName } from '../patientDetailsView';
import Mhd2Permissions from '@/constants/permissions';
import withPermission from '@/components/common/withPermission';
import withConfigEnabler from '@/components/common/withConfigOnOff';
import { compose } from 'redux';

const PatientDetailsNav = () => {
    return (
        <Nav tabs>
            <PatientInfoNavLink />
            <CoverageNavLink />
        </Nav>
    );
}

// Patient Info NavLink Component
interface PatientInfoNavLinkProps { }
const PatientInfoNavLinkComponent: React.FC<PatientInfoNavLinkProps> = () => {
    return (
        <HistoryNavLinkBase
            label="Patient Info"
            tabName={PatientInfoTabName.patientDetails}
        />
    );
};
const PatientInfoNavLink = withPermission(Mhd2Permissions.patientView)(PatientInfoNavLinkComponent);

// Coverage NavLink Component
interface CoverageNavLinkProps { }
const CoverageNavLinkComponent: React.FC<CoverageNavLinkProps> = () => {
    return (
        <HistoryNavLinkBase
            label="Coverage"
            tabName={PatientInfoTabName.coverage}
        />
    );
};
const CoverageNavLink = compose(
    withPermission(Mhd2Permissions.patientView),
    withConfigEnabler((state) => state.config.patient.enablePatientAccessCurator && state.config.patient.enablePatientAccessCuratorInsuranceCoverage)
)(CoverageNavLinkComponent) as React.FC<CoverageNavLinkProps>;

export default PatientDetailsNav;